import { render, staticRenderFns } from "./footmenu.vue?vue&type=template&id=6d89d183&"
import script from "./footmenu.vue?vue&type=script&lang=js&"
export * from "./footmenu.vue?vue&type=script&lang=js&"
import style0 from "./footmenu.vue?vue&type=style&index=0&id=6d89d183&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports